import { render, staticRenderFns } from "./pcb_ban_layout.vue?vue&type=template&id=be163944&scoped=true"
import script from "./pcb_ban_layout.vue?vue&type=script&lang=js"
export * from "./pcb_ban_layout.vue?vue&type=script&lang=js"
import style0 from "./pcb_ban_layout.vue?vue&type=style&index=0&id=be163944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be163944",
  null
  
)

export default component.exports